<template>
  <v-card-title class="pa-20">
    <template>
      <div style="width:100%;">
        <div class="push_temp__ttl" style="width:390px">
          <v-textarea
          readonly
          auto-grow
          solo
          hide-details
          row-height="1"
          class="pa-0 ma-0 s-15"
          v-model="title"
          ref="title"
        ></v-textarea>
        </div>
        <div class="push_temp__desc">
          <v-textarea
          readonly
          auto-grow
          solo
          hide-details
          row-height="1"
          class="pa-0 ma-0 fs-14"
          v-model="description"
          ref="description"
          style="font-size:15px"
        ></v-textarea>
        </div>
      </div>
    </template>
  </v-card-title>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'templateText',
  data () {
    return {
      title: '',
      description: ''
    }
  },
  destroyed () {
  },
  mounted () {
    this.initText()
  },
  computed: {
    ...mapGetters([
      'marketingTemplateContent',
      'marketingTemplateContentTitle',
      'marketingTemplateContentDescription'
    ])
  },
  watch: {
    marketingTemplateContent () {
      this.initText()
    },
    marketingTemplateContentTitle () {
      this.title = this.marketingTemplateContentTitle
    },
    marketingTemplateContentDescription () {
      this.description = this.marketingTemplateContentDescription
    }
  },
  methods: {
    ...mapMutations([
    ]),
    initText () {
      if (this.marketingTemplateContent.content) {
        let textContent = this.marketingTemplateContent.content
        this.title = textContent.title
        this.description = textContent.description
      } else {
        this.title = ''
        this.description = ''
      }
    }
  }
}
</script>

<style lang="scss">
.push_temp__ttl{
  .v-input__slot{
    padding: 0px !important;
    .v-text-field__slot{
      textarea {
        padding: 0px !important;
        font-weight: bold;
        color: #000;
      }
    }
  }
}
.push_temp__desc{
  .v-input__slot{
    padding: 0px !important;
    .v-text-field__slot{
      textarea {
        padding: 0px !important;
        color: #444444;
      }
    }
  }
}
.pa-20 {
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/push/components/templateFragments/templateText.vue